module.exports = {
  src: __webpack_public_path__ + "logo-appstore-fr-65a409ad534c474a97f46c663cf59c11.svg",
  width: 126,
  height: 40,
  bytes: 8403,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-appstore-fr-65a409ad534c474a97f46c663cf59c11.svg";
};